import { cn } from '@px-center/utils';
import loadingAnimation from 'infra/assets/images/wheel-loading.json';
import dynamic from 'next/dynamic';
import { type FC, Suspense } from 'react';
import { type Props } from './types';

const DynamicLottie = dynamic(() => import('lottie-react'), { ssr: false });

export const Loading: FC<Props> = ({ className }) => {
	return (
		<div
			role="loading-component"
			className={cn(
				'flex h-full w-full items-center justify-center',
				className,
			)}
		>
			<Suspense>
				<DynamicLottie animationData={loadingAnimation} autoplay loop />
			</Suspense>
		</div>
	);
};
